import React from 'react';

import AdminLayout from '../../components/AdminLayout';
import Requests from './Requests';

const RequestsPage = () => {
    return (
        <AdminLayout>
            <Requests />
        </AdminLayout>
    );
};

export default RequestsPage;
